module.exports = __webpack_public_path__ + "img/button-split.db4d4eb4.svg";